// based on rc-rate 2.4.3
import Rate from './src/';
export default Rate;